package com.karyadina.util

import androidx.compose.runtime.Composable
import androidx.compose.runtime.ReadOnlyComposable

@Composable
@ReadOnlyComposable
actual fun isSystemIn24HourFormat(): Boolean {
    return try {
        // Use Intl.DateTimeFormat to check for 12-hour preference
        // resolvedOptions().hour12 is a boolean or undefined
        val is12Hour = js("Intl.DateTimeFormat().resolvedOptions().hour12") as? Boolean
        
        if (is12Hour != null) {
            !is12Hour
        } else {
             // Fallback to string check
            val dateString = js("new Date().toLocaleTimeString()")
            val str = dateString.toString()
            !str.contains("AM") && !str.contains("PM")
        }
    } catch (e: Throwable) {
        true
    }
}
